var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("TitleWithRow", { attrs: { title: "Cultura e produtividade" } }),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("validation-provider", {
            attrs: {
              rules: !_vm.culturasProdutividade.length ? "required" : "",
              mode: "lazy",
              name: _vm.nomeAba + "/Cultura"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c("Label", {
                          attrs: {
                            label: "Cultura",
                            obrigatorio: !_vm.culturasProdutividade.length
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          class: { "input erro": errors.length },
                          attrs: { name: "Cultura" },
                          model: {
                            value: _vm.forms.cultura,
                            callback: function($$v) {
                              _vm.$set(_vm.forms, "cultura", $$v)
                            },
                            expression: "forms.cultura"
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(" " + _vm._s(errors[0]))
                        ])
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("validation-provider", {
            attrs: {
              rules: !_vm.culturasProdutividade.length ? "required" : "",
              mode: "lazy",
              name: _vm.nomeAba + "/Produtividade (em kg)"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c("Label", {
                          attrs: {
                            label: "Produtividade (em kg)",
                            obrigatorio: !_vm.culturasProdutividade.length
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          class: { "input erro": errors.length },
                          attrs: { name: "Produtividade (em kg)" },
                          model: {
                            value: _vm.forms.produtividade,
                            callback: function($$v) {
                              _vm.$set(_vm.forms, "produtividade", $$v)
                            },
                            expression: "forms.produtividade"
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(" " + _vm._s(errors[0]))
                        ])
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c(
            "el-col",
            { staticClass: "ml-3", attrs: { span: 4 } },
            [
              _c("div", { staticClass: "mb-1" }, [_vm._v(" ")]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    disabled: _vm.disableButton,
                    round: "",
                    type: "primary"
                  },
                  on: {
                    click: function($event) {
                      return _vm.btnAdicionar()
                    }
                  }
                },
                [_vm._v("\n        Adicionar\n      ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.culturasProdutividade.length
        ? _c("el-row", { attrs: { gutter: 20 } }, [
            _c(
              "div",
              { staticClass: "flex-wrapper row" },
              _vm._l(_vm.culturasProdutividade, function(e, i) {
                return _c(
                  "div",
                  { key: i + e.cultura },
                  [
                    _c("Card", {
                      attrs: {
                        objeto: Object.assign({}, e, {
                          produtividade: e.produtividade + " kg"
                        }),
                        deletar: function() {
                          return _vm.btnApagar(i)
                        },
                        titulo: "Cultura e produtividade"
                      }
                    })
                  ],
                  1
                )
              }),
              0
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9c24a098", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c24a098","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Forms/FormulariosProntos/CulturaProdutividade/CulturaProdutividade.vue
// module id = null
// module chunks = 